import React from 'react';
import { formatDistanceToNow } from 'date-fns';
import { CheckCircle, XCircle, Clock } from 'lucide-react';

export default function RecentActivity({ data, title = 'Recent Activity' }) {
  const getStatusIcon = (status) => {
    if (!status) return <Clock className="w-4 h-4 text-gray-500" />;
    
    switch(status.toLowerCase()) {
      case 'approved':
      case 'completed':
      case 'active':
        return <CheckCircle className="w-4 h-4 text-green-500" />;
      case 'rejected':
      case 'inactive':
        return <XCircle className="w-4 h-4 text-red-500" />;
      default:
        return <Clock className="w-4 h-4 text-yellow-500" />;
    }
  };

  const getName = (item) => {
    return item.full_name || item.name || item.organization_name || item.email || 'Unknown';
  };

  const getDate = (item) => {
    return item.created_at || item.agreed_at || item.subscribed_at || item.created_at;
  };

  return (
    <div className="card">
      <h3 className="text-lg font-semibold text-gray-900 mb-4">{title}</h3>
      <div className="space-y-4">
        {data && data.length > 0 ? (
          data.slice(0, 5).map((item, index) => (
            <div key={index} className="flex items-center justify-between py-2 border-b border-gray-100 last:border-0">
              <div className="flex items-center space-x-3 flex-1">
                {getStatusIcon(item.status)}
                <div className="flex-1 min-w-0">
                  <p className="text-sm font-medium text-gray-900 truncate">
                    {getName(item)}
                  </p>
                  <p className="text-xs text-gray-500">
                    {item.email || item.contact_email || ''}
                  </p>
                </div>
              </div>
              <div className="text-right ml-4 flex-shrink-0">
                <span className={`badge ${getStatusColor(item.status)}`}>
                  {getStatusLabel(item.status)}
                </span>
                <p className="text-xs text-gray-400 mt-1">
                  {formatDistanceToNow(new Date(getDate(item)), { addSuffix: true })}
                </p>
              </div>
            </div>
          ))
        ) : (
          <p className="text-gray-500 text-sm">No recent activity</p>
        )}
      </div>
    </div>
  );
}

// Helper functions
const getStatusColor = (status) => {
  if (!status) return 'badge-pending';
  const map = {
    pending: 'badge-pending',
    approved: 'badge-approved',
    rejected: 'badge-rejected',
    completed: 'badge-completed',
    active: 'badge-approved',
    inactive: 'badge-rejected',
  };
  return map[status.toLowerCase()] || 'badge-pending';
};

const getStatusLabel = (status) => {
  if (!status) return 'Pending';
  return status.charAt(0).toUpperCase() + status.slice(1);
};